//React
import React from "react";

//mui
import { Menu, MenuItem, ListItemIcon, Divider } from "@mui/material";
import { Logout, Person, CreditCard } from "@mui/icons-material";

//3rd party
import { useNavigate } from "react-router-dom";
import { getAuth } from "firebase/auth";

// project
import SigilAvatar from "UIComponents/SigilAvatar";

const AccountMenu = () => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleAvatarClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuItemClick = (action) => {
    setAnchorEl(null);
    switch (action) {
      case "logout":
        getAuth().signOut();
        localStorage.clear();
        sessionStorage.clear();
        break;
      //For some reason the setAnchorEl(null) is not working in a timely manner with the navigate.
      //The menu remains open after naviation and is stuck at the bottom right part of screen.
      //This is a workaround to make sure the menu closes before navigating.
      //This broke during the react 18 upgrade.
      case "profile":
        setTimeout(() => {
          navigate("/Account/Profile");
        }, 100);
        break;
      case "billing":
        setTimeout(() => {
          navigate("/Account/BillingInfo");
        }, 100);
        break;
      default:
        break;
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <SigilAvatar
        id="avatar-button"
        aria-controls={open ? "account-menu" : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-haspopup="true"
        onClick={handleAvatarClick}
      />

      <Menu
        id="account-menu"
        anchorEl={anchorEl}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        open={open}
        onClose={() => handleClose()}
      >
        <MenuItem onClick={() => handleMenuItemClick("profile")}>
          <ListItemIcon>
            <Person fontSize="small" />
          </ListItemIcon>
          Profile
        </MenuItem>
        {/* <MenuItem onClick={() => handleMenuItemClick("billing")}>
          <ListItemIcon>
            <CreditCard fontSize="small" />
          </ListItemIcon>
          Billing Info
        </MenuItem> */}
        <Divider />
        <MenuItem onClick={() => handleMenuItemClick("logout")}>
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          Logout
        </MenuItem>
      </Menu>
    </>
  );
};

export default AccountMenu;
